/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontAboutSection_seller$ref = any;
type StorefrontFeaturedSection_seller$ref = any;
type StorefrontMediaSection_seller$ref = any;
export type StorefrontHome_seller$ref = any;
export type StorefrontHome_seller = {
    readonly " $fragmentRefs": StorefrontAboutSection_seller$ref & StorefrontMediaSection_seller$ref & StorefrontFeaturedSection_seller$ref;
    readonly " $refType": StorefrontHome_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontHome_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontAboutSection_seller",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "StorefrontMediaSection_seller",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "StorefrontFeaturedSection_seller",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'b16ca51935fb6950d6a70543ba12ca26';
export default node;
